import * as React from 'react'
const styles = require('./styles/DashboardNew.scss')
import axios from 'axios'
import Store from '../store/store'
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import Checkbox from '@material-ui/core/Checkbox';
import { observer } from "mobx-react";
import { RouteComponentProps, withRouter } from 'react-router-dom';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import DocPreview from '../search/docPreview/DocPreview';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import ListItemText from '@material-ui/core/ListItemText';
import Compteur from './compteur/Compteur';
import Spinner from '../Spinner/Spinner';
import Popover from '@material-ui/core/Popover';
import InfoOutlined from '@material-ui/icons/InfoOutlined';
import Icon from '@material-ui/core/Icon'
import { DialogFooter, DialogType, Dialog as DialogFabric } from "office-ui-fabric-react/lib/Dialog";
import { PrimaryButton, DefaultButton } from "office-ui-fabric-react/lib/Button";

interface ISearchResultTask {
  idWf: number;
  nameWf: string;
  stateWf: "En retard" | "En cours" | "Terminé" | "Refusé" | "En attente de traitement" | "En risque de retard";
  nameTask: string;
  stateTask: "En cours" | "Terminée" | "Refusé" | "En préparation" | "Annulé";
  dateStartProject: Date;
  doc: string;
  documentIsForm: boolean;
  documentGestionnaireId: { id: number; type: "manuel" | "auto" }[];
  idTask: number;
  stepId: number;
  stepIsCollab:boolean;

  stepIsAllowApprop:boolean;
  docDataSharepoint: any;
  stateStep: "En cours" | "Terminée" | "Refusé" | "En préparation" | "Annulé";
  acteurTask: {
    isGroup: boolean;
    lastname: string;
    firstname: string;
    usersOfGroup: number[];
    idUser: number;
  },
  emailActeur: string;
  isDiffered: boolean;
  taskView: boolean;
  taskDateDone: Date;
}

interface State {
  ongletSelect: number;
  popOverInfo: {
    open: boolean;
    anchorEl: any;
  };
  // TASKS ////
  loadingTasks?: boolean;
  sortTasks: ISearchResultTask[];
  allTasks: ISearchResultTask[];
  allGedProject: ISearchResultTask[];
  sortAllGedProject: ISearchResultTask[];
  filterTask: string[];
  filterProject: string[];
  // END TASKS ////
  // MESSAGES ////
  loadingMessages: boolean;
  filterMessage: string[];
  myMessagesSend: any[];
  allMessage: any[];
  messageForMe: any[];
  messageToDisplay: any[];
  // END MESSAGES ////
  docPreview: {
    open: boolean;
    anchorEl: any;
    docData: any;
    documentIsForm: boolean;
  };
  appropDialogIsHidden:boolean;
  selectedRow:any;
}

const Window: any = window;

@observer
class DashboardNew extends React.Component<RouteComponentProps<any>, State> {

  public constructor(props: any) {
    super(props)
    const today = new Date();
    const last2mounth = new Date(today.getFullYear(), today.getMonth() - 1, 0); // pour régler le date picker a 2 mois en arrière , à modifier au besoin
    last2mounth.setDate(Math.min(today.getDate(), last2mounth.getDate()));

    this.state = {
      ongletSelect: 0,
      popOverInfo: {
        open: false,
        anchorEl: null
      },
      ///TASKS///
      loadingTasks: true,
      filterTask: Window.MY_TASKS_CONFIG != undefined && Window.MY_TASKS_CONFIG != null && Window.MY_TASKS_CONFIG.length > 0 ? Window.MY_TASKS_CONFIG : [],
      allTasks: [],
      sortTasks: [],
      allGedProject: [],
      sortAllGedProject: [],
      filterProject: ["En cours", "En risque de retard", "En retard"],
      /// END TASKS ////
      /// MESSAGES ////
      loadingMessages: true,
      filterMessage: ["En préparation", "En cours"],
      messageForMe: [],
      myMessagesSend: [],
      allMessage: [],
      messageToDisplay: [],
      /// END MESSAGES ////
      docPreview: {
        open: false,
        anchorEl: null,
        docData: null,
        documentIsForm: false
      },
      selectedRow:{},
      appropDialogIsHidden:true
    }
  }

  componentDidMount() {
    this.getAllTasksByUser();
    this.getTaskPostItByUser();
  }

  ////// TASKS //////////////////////////////////////////////////////////////////////
  public displayDocumentName = (taskData?: boolean) => (cell, row: ISearchResultTask) => {
    const style: React.CSSProperties = { display: "inline-block", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden", maxWidth: "100%" };
    // Si la tâche n'a pas été vu par l'utilisateur on la mets en gras
    if (row.taskView == false && taskData == true) {
      style["fontWeight"] = "bold";
    }
    let link = "/document?w=" + row.idWf + "&s=" + row.stepId + "&t=" + row.idTask;
    return <a href={link} target="_self"><span style={style} onMouseOver={this.openDocPreview(row)} onMouseOut={this.closeDocPreview} title={cell}>{cell}</span></a>
  }

  public displayProjectName = (cell: string, row: any) => {
    const style: React.CSSProperties = { overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis" };
    let link = "/document?w=" + row.idProject + "&s=" + row.stepId + "&t=" + row.taskId;
    return <a href={link} target="_self" style={style}>{cell}</a>
  }

  public openDocPreview = (row: ISearchResultTask) => (event) => {
    const docData = row;
    this.setState({
      docPreview: {
        open: true,
        anchorEl: event.currentTarget,
        docData: docData.docDataSharepoint,
        documentIsForm: docData.documentIsForm
      }
    });
  }

  public closeDocPreview = (event) => {
    this.setState({
      docPreview: {
        open: false,
        anchorEl: null,
        docData: null,
        documentIsForm: false
      }
    });
  }
  public openCloseAppropDialogModal = (row?) => {
    if (this.state.appropDialogIsHidden == false) {
      this.setState({appropDialogIsHidden:true,selectedRow:{}}) 
    }else{
      this.setState({appropDialogIsHidden:false,selectedRow:row})
    }
  }
  public getAllTasksByUser = () => {
    this.setState({ loadingTasks: true }, () => {
      axios.post(Store.wsPath + '/1/workflows/returnResultSearchFilter', {
        search: {
          choiceUser: [Store.userConnected.id],
          choiceGed: [Store.userConnected.id]
        },
        idUser: Store.userConnected.id,
        objectChoice: [],
        choiceTaskproject: "task",
        includeArchived: false,
        offset: 0
      }).then((responseTask) => {
        const allTasksAndGestionnaire: ISearchResultTask[] = responseTask.data.rows;
        // On enléve prend que les tâches on enlève celles ou il est gestionnaire
        const allTask = allTasksAndGestionnaire.filter(task => task.acteurTask.idUser == Store.userConnected.id);
        // On récupére les taches ou l'utilisateur connnecté est ged
        const allGedTasks = allTasksAndGestionnaire.filter(task => task.documentGestionnaireId.find(user => user.id == Store.userConnected.id) != undefined);
        // Puis on les fait en projet pour pouvoir afficher les projets ou l'utilisateur est ged
        const allGedProject = [];
        allGedTasks.forEach(task => {
          if (allGedProject.find(proj => proj.idWf == task.idWf) == undefined) {
            let newTask = { ...task };
            const allTaskEnCoursInProject = allGedTasks.filter(proj => proj.idWf == task.idWf && proj.stateTask == "En cours");
            if (allTaskEnCoursInProject.length > 0) {
              newTask = { ...allTaskEnCoursInProject[0] };
            }
            // Const on rajoute l'identifiant chrono qui est dnas le dataSharePoint
            newTask["identifiantChrono"] = task.docDataSharepoint.sherpa_WorkflowIdChrono != undefined && task.docDataSharepoint.sherpa_WorkflowIdChrono != null ? task.docDataSharepoint.sherpa_WorkflowIdChrono : "";
            newTask["taskEnCours"] = newTask.stateTask == "En cours" ? newTask.nameTask : "Aucune";
            allGedProject.push(newTask);
          }
        });

        // On applique les filtres de l'utilisateur
        const allTasksFilter = this.trierTasks(allTask);

        // On applique les filtres de l'utilisateur sur les projects si il est gestionnaire
        const allGedProjectFilter = this.trierProjects(allGedProject);

        this.setState({ allTasks: allTask, loadingTasks: false, allGedProject: allGedProject, sortTasks: allTasksFilter, sortAllGedProject: allGedProjectFilter });
      }).catch(error => {
        console.error("Error 'getAllTasksByUser' : ", error);
        this.setState({ loadingTasks: false }, () => {
          Store.snackBar = {
            message: "Une erreur est survenue lors de la récupération des tâches",
            error: true,
            open: true
          };
        });
      });
    });
  }

  public isDiffered = (cell, row: ISearchResultTask) => {
    return row.isDiffered == true ? "Oui" : "Non"
  }

  //Fonction qui permet de filtrer les tâches par rapport au filtres cochés par l'user
  public trierTasks = (taskToFilter: ISearchResultTask[]) => {
    const tempSortTasks: ISearchResultTask[] = [];
    if (this.state.filterTask.includes("En préparation")) {
      taskToFilter.forEach(task => {
        if (task.stateTask == "En préparation" && task.isDiffered == false) {
          tempSortTasks.push(task);
        }
      });
    }
    if (this.state.filterTask.includes("En cours")) {
      taskToFilter.forEach(task => {
        if (task.stateTask == "En cours" && task.isDiffered == false) {
          tempSortTasks.push(task);
          Store.countTaskUser = taskToFilter.filter(task => task.stateTask == "En cours").length;
        }
      });
    }
    if (this.state.filterTask.includes("Terminée")) {
      taskToFilter.forEach(task => {
        if (task.stateTask == "Terminée" && task.isDiffered == false) {
          tempSortTasks.push(task);
        }
      });
    }
    if (this.state.filterTask.includes("Refusé")) {
      taskToFilter.forEach(task => {
        if ((task.stateTask == "Refusé" || task.stateTask == "Annulé") && task.isDiffered == false) {
          tempSortTasks.push(task);
        }
      });
    }
    if (this.state.filterTask.includes("Différée")) {
      taskToFilter.forEach(task => {
        if (task.isDiffered == true && task.stateTask == "En cours") {
          tempSortTasks.push(task);
        }
      });
    }
    return tempSortTasks;
  }

  //Fonction qui permet de filtrer les projets par rapport au filtres cochés par l'user dans la partie gestionnaire
  public trierProjects = (projectToFilter: ISearchResultTask[]) => {
    const tempSortProject: ISearchResultTask[] = [];
    if (this.state.filterProject.includes("En attente de traitement")) {
      projectToFilter.forEach(project => {
        if (project.stateWf == "En attente de traitement") {
          tempSortProject.push(project);
        }
      });
    }
    if (this.state.filterProject.includes("En cours")) {
      projectToFilter.forEach(project => {
        if (project.stateWf == "En cours") {
          tempSortProject.push(project);
        }
      });
    }
    if (this.state.filterProject.includes("En risque de retard")) {
      projectToFilter.forEach(project => {
        if (project.stateWf == "En risque de retard") {
          tempSortProject.push(project);
        }
      });
    }
    if (this.state.filterProject.includes("En retard")) {
      projectToFilter.forEach(project => {
        if (project.stateWf == "En retard") {
          tempSortProject.push(project);
        }
      });
    }
    if (this.state.filterProject.includes("Terminé")) {
      projectToFilter.forEach(project => {
        if (project.stateWf == "Terminé") {
          tempSortProject.push(project);
        }
      });
    }
    if (this.state.filterProject.includes("Refusé")) {
      projectToFilter.forEach(project => {
        if (project.stateWf == "Refusé") {
          tempSortProject.push(project);
        }
      });
    }
    return tempSortProject;
  }

  private onChangeTask = (event) => {
    this.setState({ filterTask: event.target.value }, () => {
      const taskFilter = this.trierTasks(this.state.allTasks);
      this.setState({ sortTasks: taskFilter });
    });
  }

  private onChangeProject = (event) => {
    this.setState({ filterProject: event.target.value }, () => {
      const projectFilter = this.trierProjects(this.state.allGedProject);
      this.setState({ sortAllGedProject: projectFilter });
    });
  }
  ///// END TASKS //////

  ///// MESSAGES ///////
  private onChangeMessage = (event) => {
    this.setState({ filterMessage: event.target.value }, () => {
      const messageFilter = this.trierMessage(this.state.allMessage);
      this.setState({ messageToDisplay: messageFilter });
    });
  }
  private getTaskPostItByUser() {
    axios.get(Store.wsPath + '/1/postIt/getTaskPostItByUser', {
      params: {
        idUserConnected: Store.userConnected.id
      }
    }).then(async response => {
      this.toSetDataForTable(response.data);
    });
  }

  private toSetDataForTable(allPostItBlue: { myMessage: any[], forMe: any[] }) {
    this.setState({ loadingMessages: true }, () => {
      const allMyMessage: any[] = [];
      const allForMeMessage: any[] = [];
      const allMessage: any[] = [];

      if (allPostItBlue.forMe != undefined && allPostItBlue.forMe != null && allPostItBlue.forMe.length > 0) {
        for (let i = 0; i < allPostItBlue.forMe.length; i++) {
          if (allPostItBlue.forMe[i].TaskPostIts.length > 0) {
            for (let j = 0; j < allPostItBlue.forMe[i].TaskPostIts.length; j++) {
              allPostItBlue.forMe[i].TaskPostIts[j].PostItMessages.forEach(message => {
                // A modifier en mode sherPoint
                const tempObject = {
                  id: message.id,
                  date: message.createdAt,
                  message: message.message,
                  idUserQuiAEcritLeMessage: message.idxUser,
                  idDestinataire: allPostItBlue.forMe[i].userIdx,
                  idProject: allPostItBlue.forMe[i].WfStep.WfProject.id,
                  stateStep: allPostItBlue.forMe[i].WfStep.state,
                  designationProjet: allPostItBlue.forMe[i].WfStep.WfProject.name,
                  idPostIt: allPostItBlue.forMe[i].TaskPostIts[j].id,
                  taskName: allPostItBlue.forMe[i].name,
                  stateTask: allPostItBlue.forMe[i].state,
                  stepId: allPostItBlue.forMe[i].WfStep.id,
                  taskId: allPostItBlue.forMe[i].id
                }

                allForMeMessage.push(tempObject);
                allMessage.push(tempObject);
              });
            }
          }
        }
      }

      if (allPostItBlue.myMessage != undefined && allPostItBlue.myMessage != null && allPostItBlue.myMessage.length > 0) {
        for (let i = 0; i < allPostItBlue.myMessage.length; i++) {
          if (allPostItBlue.myMessage[i].TaskPostIts.length > 0) {
            for (let j = 0; j < allPostItBlue.myMessage[i].TaskPostIts.length; j++) {
              allPostItBlue.myMessage[i].TaskPostIts[j].PostItMessages.forEach(message => {
                // A modifier en mode sherPoint
                const tempObject = {
                  id: message.id,
                  date: message.createdAt,
                  message: message.message,
                  idUserQuiAEcritLeMessage: message.idxUser,
                  idDestinataire: allPostItBlue.myMessage[i].userIdx,
                  idProject: allPostItBlue.myMessage[i].WfStep.WfProject.id,
                  stateStep: allPostItBlue.myMessage[i].WfStep.state,
                  designationProjet: allPostItBlue.myMessage[i].WfStep.WfProject.name,
                  idPostIt: allPostItBlue.myMessage[i].TaskPostIts[j].id,
                  taskName: allPostItBlue.myMessage[i].name,
                  stateTask: allPostItBlue.myMessage[i].state,
                  stepId: allPostItBlue.myMessage[i].WfStep.id,
                  taskId: allPostItBlue.myMessage[i].id
                }

                allMyMessage.push(tempObject)
                allMessage.push(tempObject);
              });
            }
          }
        }
      }

      const sortMessage = Array.from(new Set(this.trierMessage(allMessage)));

      this.setState({ myMessagesSend: allMyMessage, messageForMe: allForMeMessage, allMessage: allMessage, messageToDisplay: sortMessage, loadingMessages: false });
    });
  }
  public convertUser = (idUser) => {
    if (Store.userConnected.id == idUser) {
      return "Vous"
    } else {
      const tempUserFind = Store.allUsers.find(user =>
        user.id == idUser
      )
      if (tempUserFind != undefined || null) {
        return tempUserFind.firstname + ' ' + tempUserFind.lastname
      }
      else {
        return "Auteur introuvable"
      }
    }
  }

  public trierMessage = (messageToFilter: any[]) => {
    const finalTempArrayMessages: any[] = [];
    if (this.state.filterMessage.includes("En préparation")) {
      messageToFilter.forEach(message => {
        if (message.stateTask == "En préparation") {
          finalTempArrayMessages.push(message);
        }
      });
    }
    if (this.state.filterMessage.includes("En cours")) {
      messageToFilter.forEach(message => {
        if (message.stateTask == "En cours") {
          finalTempArrayMessages.push(message);
        }
      });
    }
    if (this.state.filterMessage.includes("Terminée")) {
      messageToFilter.forEach(message => {
        if (message.stateTask == "Terminée") {
          finalTempArrayMessages.push(message);
        }
      });
    }
    if (this.state.filterMessage.includes("Refusé")) {
      messageToFilter.forEach(message => {
        if (message.stateTask == "Refusé" || message.stateTask == "Annulé") {
          finalTempArrayMessages.push(message);
        }
      });
    }

    return finalTempArrayMessages;
  }
  ///// END MESSAGES ////////

  public convertDate = (cell:Date, row) => {
    const newDate = new Date(cell);
    if ((newDate.getMonth() + 1) < 10) {
      if (newDate.getDate() < 10) {
        return "0" + newDate.getDate() + "/0" + (newDate.getMonth() + 1) + "/" + newDate.getFullYear();
      }
      else {
        return newDate.getDate() + "/0" + (newDate.getMonth() + 1) + "/" + newDate.getFullYear();
      }
    } else {
      if (newDate.getDate() < 10) {
        return "0" + newDate.getDate() + "/" + (newDate.getMonth() + 1) + "/" + newDate.getFullYear();
      }
      else {
        return newDate.getDate() + "/" + (newDate.getMonth() + 1) + "/" + newDate.getFullYear();
      }
    }
  }
  public approbStep = (row) => {
    axios.post(Store.wsPath + "/1/workflows/approbStep", {
        task: {id:row.idTask,stepId:row.stepId ,WfStep:{id:row.stepId,projetId:row.idWf,name:row.nameTask,isAllowApprop:row.stepIsAllowApprop}},
        user: Store.userConnected
    }).then((response) => {
      const temp:any[] = this.state.sortTasks.map(el => el.idTask == row.idTask ? {...el, stepIsAlreadyApprop:true} : el);
      this.setState({appropDialogIsHidden:true,selectedRow:{},sortTasks:temp})
      Store.snackBar = {
        error: false,
        message: "Tâche correctement appropriée",
        open: true
    }
    }).catch(error => {
        this.setState({appropDialogIsHidden:true,selectedRow:{}})
        console.error("approbStep : " + error)
        Store.snackBar.message = "Une erreur s'est produite lors de l'appropriation de la tâche, réessayez"
        Store.snackBar.open = true;
        Store.snackBar.error = true;
    });
    
}
  onChangeOngletTaskOrGed = (event: React.ChangeEvent<{}>, newValue: number) => {
    this.setState({ ongletSelect: newValue });
  }
  public toolbox= (cell: string, row) => {
    let component = <React.Fragment></React.Fragment>
    if(row.stepIsAllowApprop == true && row.stepIsAlreadyApprop == false){
      component = (
        <React.Fragment>
          <Icon style={{cursor:"pointer"}} title="S'approprier" onClick={()=>this.openCloseAppropDialogModal(row)} className={styles.icon}>hail</Icon>
        </React.Fragment>
      )
    }
    return (
      <div className={styles.toolboxContainer}>
        {component}
      </div>
    )
  }
  public render() {
    const optionsMessages = {
      sortIndicator: true,
      defaultSortName: 'id',
      noDataText: 'Aucun message à afficher',
      sizePerPage: 10,
    };

    const optionsTasks = {
      sortIndicator: true,
      defaultSortName: 'circuitName',
      noDataText: "Aucune tâche à afficher",
      sizePerPage: 10,
    };
    // Liste des choix des statuts pour les tâches
    const statutFilterListTask = [
      "En préparation",
      "En cours",
      "Terminée",
      "Refusé",
      "Différée"
    ];

    // Liste des choix des statuts pour les projets dans la partie gestionnaire
    const statutFilterListProjet = ["En cours", "En risque de retard", "En retard", "Terminé", "Refusé", "En attente de traitement"];

    // Liste des choix des statuts pour les messages
    const statutFilterListMessage = [
      "En préparation",
      "En cours",
      "Terminée",
      "Refusé"
    ];
    return (
      <div className={"mainContent"}>
        <div className="titleComponent" style={{ background: Store.themeParam.backgroundPrimary }}><h5>Mon tableau de bord</h5></div>
        <div className={"contentComponent " + styles.dashboardContainer}>
          {/* Partie compteur */}
          <div className={styles.compteurContainer}>
            <div className={styles.contentComponent}>
              {this.state.loadingTasks == true ?
                <Spinner />
                :
                <Compteur
                  title="Tâches terminées sur les 30 derniers jours"
                  value={this.state.allTasks.filter(task => {
                    const today = new Date();
                    today.setDate(new Date().getDate() - 30);
                    if (task.stateTask == "Terminée" && task.taskDateDone != null && new Date(task.taskDateDone) > today) {
                      return true;
                    }
                    else {
                      return false;
                    }
                  }).length}
                />
              }
            </div>
            <div className={styles.contentComponent}>
              {this.state.loadingTasks == true ?
                <Spinner />
                :
                <Compteur
                  title="Tâches en cours"
                  value={this.state.allTasks.filter(task => task.stateTask == "En cours" && task.isDiffered == false).length}
                />
              }
            </div>
            <div className={styles.contentComponent}>
              {this.state.loadingTasks == true ?
                <Spinner />
                :
                <Compteur
                  title="Tâches différées"
                  value={this.state.allTasks.filter(task => task.stateTask == "En cours" && task.isDiffered == true).length}
                />
              }
            </div>
            {/* <div className={styles.contentComponent}>
              <h6>Compteur 4</h6>
            </div> */}
          </div>

          {/* Partie qui contient Mes taches et mes messages */}
          <div className={styles.taskAndMessagesContainer}>
            {/* Partie mes taches et gestionnaire */}
            <div className={styles.contentComponent + " " + styles.content}>
              {this.state.loadingTasks == true ?
                <Spinner fullWidth={true} style={{ minHeight: "150px" }} />
                :
                <React.Fragment>
                  <div className={styles.contentHeader}>
                    <div className={styles.titlecontainer}>
                      {
                        this.state.allGedProject.length > 0 ?
                          <Tabs classes={{ root: styles.tabsContainer, indicator: styles.tabIndicator + " tab" + this.state.ongletSelect }} value={this.state.ongletSelect} onChange={this.onChangeOngletTaskOrGed} aria-label="tabs dashboard" centered>
                            <Tab classes={{ root: styles.tab }} label="Mes tâches" id="Mes-taches-tab" aria-controls="Mes-taches-tab" />
                            <Tab classes={{ root: styles.tab }} label="Mon espace gestionnaire" id="Mon-espace-ged-tab" aria-controls="Mon-espace-ged-tab" />
                          </Tabs>
                          :
                          this.state.ongletSelect == 0 ?
                            <h6>Mes tâches</h6>
                            :
                            <h6 />
                      }
                      <InfoOutlined className={styles.infoIcon} onClick={(event) => this.setState({ popOverInfo: { open: true, anchorEl: event.currentTarget } })} />
                      <Popover
                        open={this.state.popOverInfo.open}
                        anchorEl={this.state.popOverInfo.anchorEl}
                        onClose={() => this.setState({ popOverInfo: { open: false, anchorEl: null } })}
                        anchorOrigin={{
                          vertical: 'bottom',
                          horizontal: 'center',
                        }}
                        transformOrigin={{
                          vertical: 'top',
                          horizontal: 'center',
                        }}
                        className={styles.popoverContainer}
                      >
                        <p className={styles.popoverContent}>Les circuits refusés ou terminés de plus de 30 jours ne sont pas affichés.<br />Si vous souhaitez les consulter, veuillez utiliser la recherche.</p>
                      </Popover>
                    </div>
                    {
                      this.state.ongletSelect == 0 ?
                        <FormControl size="small">
                          <InputLabel id="statut-task-label">Statut tâche</InputLabel>
                          <Select
                            labelId="statut-task-label"
                            multiple
                            value={this.state.filterTask}
                            onChange={this.onChangeTask}
                            input={<OutlinedInput label="Statut tâche" />}
                            renderValue={(selected: string[]) => selected.join(', ')}
                            MenuProps={{
                              PaperProps: {
                                style: {
                                  // maxHeight: 48 * 4.5 + 8,
                                  width: 250,
                                },
                              },
                            }}
                            style={{ minWidth: "90px" }}
                          >
                            {statutFilterListTask.map((name) => (
                              <MenuItem key={name + "map1"} value={name}>
                                <Checkbox checked={this.state.filterTask.includes(name)} />
                                <ListItemText primary={name} />
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                        :
                        <FormControl size="small">
                          <InputLabel id="statut-task-label">Statut circuit</InputLabel>
                          <Select
                            labelId="statut-task-label"
                            multiple
                            value={this.state.filterProject}
                            onChange={this.onChangeProject}
                            input={<OutlinedInput label="Statut circuit" />}
                            renderValue={(selected: string[]) => selected.join(', ')}
                            MenuProps={{
                              PaperProps: {
                                style: {
                                  // maxHeight: 48 * 4.5 + 8,
                                  width: 250,
                                },
                              },
                            }}
                            style={{ minWidth: "90px" }}
                          >
                            {statutFilterListProjet.map((name) => (
                              <MenuItem key={name + "map2"} value={name}>
                                <Checkbox checked={this.state.filterProject.includes(name)} />
                                <ListItemText primary={name} />
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                    }
                  </div>

                  {/* Mes tâches */}
                  {
                    this.state.ongletSelect == 0 ?
                      <BootstrapTable
                        multiColumnSearch
                        multiColumnSort ={4}
                        data={this.state.sortTasks}
                        searchPlaceholder='Rechercher dans la liste'
                        search={true}
                        options={optionsTasks}
                        className={styles.contentMyTasks}
                        bordered={false}
                        // headerStyle={{ zIndex: 220, position: "relative" }}
                        pagination
                        version='4'
                        size="sm"
                      >
                        <TableHeaderColumn isKey={true} dataField='idTask' hidden >Id</TableHeaderColumn>
                        <TableHeaderColumn dataField='nameWf' dataFormat={this.displayDocumentName(true)} dataSort={true}>Circuit</TableHeaderColumn>
                        <TableHeaderColumn dataField='stateWf' dataAlign='center' headerAlign='center' dataSort>Statut circuit</TableHeaderColumn>
                        <TableHeaderColumn dataField='dateStartProject' dataAlign='center' headerAlign='center' dataSort dataFormat={this.convertDate}>Début du circuit</TableHeaderColumn>
                        <TableHeaderColumn dataField='nameTask' dataAlign='center' headerAlign='center' dataSort>Tâche</TableHeaderColumn>
                        <TableHeaderColumn dataField='stateTask' dataAlign='center' headerAlign='center' dataSort>Statut tâche</TableHeaderColumn>
                        <TableHeaderColumn dataField='isDiffered' dataAlign='center' headerAlign='center' dataFormat={this.isDiffered} dataSort>Différée</TableHeaderColumn>

                        {/* <TableHeaderColumn dataField='updatedAt' width="120px" dataSort={true} dataFormat={this.convertDateFromDataBaseToDisplaying} >Date Maj</TableHeaderColumn> */}
                        {/* <TableHeaderColumn dataField='dateFinSouhaitee' width="120px" dataFormat={this.convertEstimateDateFromDataBaseToDisplaying} dataSort caretRender={this.getCaret} sortFunc={this.sortDateSouhaite} >Date de fin estimée</TableHeaderColumn> */}
                        {/* <TableHeaderColumn dataField='dateDone' width="120px" dataFormat={this.convertDateFromDataBaseToDisplaying} dataSort caretRender={this.getCaret} sortFunc={this.sortDateDone}>Date de fin réelle</TableHeaderColumn> */}
                        <TableHeaderColumn width='82px' dataField='action' dataFormat={this.toolbox} >Actions</TableHeaderColumn>
                      </BootstrapTable>
                      :
                      <React.Fragment />
                  }


                  {/* Mes projets ou je suis gestionnaire */}
                  {
                    this.state.ongletSelect == 1 ?
                      <BootstrapTable
                        multiColumnSearch
                        multiColumnSort ={4}
                        data={this.state.sortAllGedProject}
                        searchPlaceholder='Rechercher dans la liste'
                        search={true}
                        options={optionsTasks}
                        className={styles.contentMyTasks}
                        bordered={false}
                        pagination
                        version='4'
                        size="sm"
                      >
                        <TableHeaderColumn isKey={true} dataField='idWf' hidden>Id</TableHeaderColumn>
                        <TableHeaderColumn dataField='nameWf' dataFormat={this.displayDocumentName()} dataSort={true}>Circuit</TableHeaderColumn>
                        <TableHeaderColumn dataField='stateWf' dataAlign='center' headerAlign='center' dataSort>Statut circuit</TableHeaderColumn>
                        <TableHeaderColumn dataField='taskEnCours' dataAlign='center' headerAlign='center' dataSort>Étape en cours</TableHeaderColumn>
                        <TableHeaderColumn dataField='dateStartProject' dataAlign='center' headerAlign='center' dataSort dataFormat={this.convertDate}>Date de début</TableHeaderColumn>
                        <TableHeaderColumn dataField='identifiantChrono' dataAlign='center' headerAlign='center' dataSort>Identifiant chrono</TableHeaderColumn>
                      </BootstrapTable>
                      :
                      <React.Fragment />
                  }
                  {
                    this.state.docPreview.documentIsForm == false ?
                      <DocPreview open={this.state.docPreview.open} anchorEl={this.state.docPreview.anchorEl} docData={this.state.docPreview.docData} />
                      :
                      <React.Fragment />
                  }
                </React.Fragment>
              }
            </div>



            {/* Partie mes messages */}
            <div className={styles.contentComponent + " " + styles.content}>
              {this.state.loadingMessages == true ?
                <Spinner fullWidth={true} style={{ minHeight: "150px" }} />
                :
                <div>
                  {/* Mes messages */}
                  <div className={styles.contentHeader}>
                    <h6>Mes messages</h6>
                    <FormControl size="small">
                      <InputLabel id="statut-task-label">Statut tâche</InputLabel>
                      <Select
                        labelId="statut-task-label"
                        multiple
                        value={this.state.filterMessage}
                        onChange={this.onChangeMessage}
                        input={<OutlinedInput label="Statut tâche" />}
                        renderValue={(selected: string[]) => selected.join(', ')}
                        MenuProps={{
                          PaperProps: {
                            style: {
                              width: 250
                            },
                          },
                        }}
                        style={{ minWidth: "90px" }}
                      >
                        {statutFilterListMessage.map((name) => (
                          <MenuItem key={name + "map3"} value={name}>
                            <Checkbox checked={this.state.filterMessage.includes(name)} />
                            <ListItemText primary={name} />
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </div>

                  <BootstrapTable
                    multiColomnSearch
                    data={this.state.messageToDisplay}
                    searchPlaceholder='Rechercher dans la liste'
                    search={true}
                    options={optionsMessages}
                    pagination
                    version='4'
                    bordered={true}
                    className={styles.contentMyTasks}
                    trStyle={{ cursor: "pointer" }}
                  >
                    <TableHeaderColumn isKey={true} dataField='id' hidden dataAlign='center' headerAlign='center'>id</TableHeaderColumn>
                    <TableHeaderColumn datasort={true} dataField='designationProjet' dataFormat={this.displayProjectName}>Circuit</TableHeaderColumn>
                    <TableHeaderColumn datasort={true} dataField='taskName' dataAlign='center' headerAlign='center'>Tâche</TableHeaderColumn>
                    <TableHeaderColumn dataField='stateTask' dataAlign='center' headerAlign='center' dataSort>Statut tâche</TableHeaderColumn>
                    <TableHeaderColumn datasort={true} dataField='idUserQuiAEcritLeMessage' dataFormat={this.convertUser} dataAlign='center' headerAlign='center'>Auteur</TableHeaderColumn>
                    <TableHeaderColumn datasort={true} dataField='idDestinataire' dataFormat={this.convertUser} dataAlign='center' headerAlign='center'>Destinataire</TableHeaderColumn>
                    <TableHeaderColumn datasort={true} dataField='date' dataFormat={this.convertDate} dataAlign='center' headerAlign='center'>Date</TableHeaderColumn>
                    <TableHeaderColumn datasort={true} dataField='message' dataAlign='center' headerAlign='center'>Message</TableHeaderColumn>
                  </BootstrapTable>
                </div>
              }
            </div>
          </div>
        </div>
        <DialogFabric
          hidden={this.state.appropDialogIsHidden}
          onDismiss={this.openCloseAppropDialogModal}
          dialogContentProps={{
            type: DialogType.normal,
            title: "S'approprier la tâche",
            closeButtonAriaLabel: 'Fermer',
          }}
          modalProps={{
            isBlocking: true
          }}
        >
          <React.Fragment>
            <p>Vous allez vous approprier la tâche.</p>
            <p>Attention, en vous appropriant la tâche, toute les autres personnes sur la même étape seront retirées.</p>
            <p>Après l'appropriation, cette tâche apparaitra uniquement sur votre tableau de bord.</p>
            <DialogFooter>
              <PrimaryButton onClick={()=>this.approbStep(this.state.selectedRow)} text="Confirmer" />
              <DefaultButton onClick={()=>this.openCloseAppropDialogModal()} text="Annuler" />
            </DialogFooter>
          </React.Fragment>
        </DialogFabric>
      </div >
    )
  }
}

export default withRouter(DashboardNew);